import { CircularProgress, Grid, TextField } from '@mui/material';
import React, { type FC } from 'react';

type FieldProps = {
	isSubmitting: boolean;
	CancelButton?: any;
};

const HostedFieldInput = (fieldId: string) => (
	<div
		id={fieldId}
		style={{
			height: '50px',
			marginLeft: '10px',
		}}
	/>
);

const SlidePayCreditCardFields: FC<FieldProps> = ({ CancelButton, isSubmitting }) => (
	<>
		<Grid container spacing={2} marginTop={0.5}>
			<Grid item xs={6} minWidth='200px'>
				<TextField
					required
					name='card-number'
					variant='outlined'
					fullWidth
					label='Card Number'
					InputLabelProps={{ shrink: true }}
					InputProps={{
						inputComponent: () => HostedFieldInput('sp-card-number'),
					}}
				/>
			</Grid>
			<Grid item xs={3} minWidth='110px'>
				<TextField
					required
					name='expiration-date'
					variant='outlined'
					fullWidth
					label='Expiration Date'
					InputLabelProps={{ shrink: true }}
					InputProps={{
						inputComponent: () => HostedFieldInput('sp-card-exp'),
					}}
				/>
			</Grid>
			<Grid item xs={2} minWidth='90px'>
				<TextField
					required
					name='card-cvv'
					variant='outlined'
					fullWidth
					label='CVC Code'
					InputLabelProps={{ shrink: true }}
					InputProps={{
						inputComponent: () => HostedFieldInput('sp-card-cvv'),
					}}
				/>
			</Grid>
			<Grid item xs={6} minWidth='260px'>
				<TextField
					required
					name='cardholder-name'
					variant='outlined'
					fullWidth
					label='Cardholder Name'
					InputLabelProps={{ shrink: true }}
					InputProps={{
						inputComponent: () => HostedFieldInput('sp-cardholder-name'),
					}}
				/>
			</Grid>
		</Grid>
		<Grid container spacing={2} marginTop={0.5} alignItems='center'>
			<Grid item xs={3} minWidth='150px'>
				<div id='submit-btn' className='pca__slidePay-submit-btn' />
			</Grid>
			{CancelButton && !isSubmitting ? (
				<Grid item xs={3}>
					<CancelButton />
				</Grid>
			) : null}
			{isSubmitting && (
				<Grid item xs={2}>
					<CircularProgress size={30} />
				</Grid>
			)}
		</Grid>
	</>
);

export default React.memo(SlidePayCreditCardFields);
